// Others
import axiosClient from './axiosClient';
import { urlApiPurchaseOrder } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IBodyUpdate } from '~/utils/interface/common';
import {
  IPurchaseOrderDetail,
  IFormPurchaseOrder,
  IQueryParamPurchaseOrder,
  IPurchaseOrder,
  IFormChangeStatusPO,
  IQueryDetailPurchaseOrder,
} from '~/utils/interface/purchaseOrder';

const purchaseOrderApi = {
  getListPurchaseOrder: (params: IQueryParamPurchaseOrder) => {
    const url = urlApiPurchaseOrder.getListPurchaseOrder;
    return axiosClient.get<IBaseResponse<IListDataResponse<IPurchaseOrder[]>>>(url, { params });
  },

  getDetailPurchaseOrder: (query: IQueryDetailPurchaseOrder) => {
    const { id, params } = query;

    const url = urlApiPurchaseOrder.getDetailPurchaseOrder(id);
    return axiosClient.get<IBaseResponse<IPurchaseOrderDetail>>(url, { params });
  },

  createPurchaseOrder: (body: IFormPurchaseOrder) => {
    const url = urlApiPurchaseOrder.createPurchaseOrder;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  updatePurchaseOrder: (params: IBodyUpdate<IFormPurchaseOrder>) => {
    const { id, body } = params;
    const url = urlApiPurchaseOrder.updatePurchaseOrder(id);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  deletePurchaseOrder: (id: string) => {
    const url = urlApiPurchaseOrder.deletePurchaseOrder(id);
    return axiosClient.delete<IBaseResponse>(url);
  },

  changeStatusPurchaseOrder: (params: IBodyUpdate<IFormChangeStatusPO>) => {
    const { id, body } = params;
    const url = urlApiPurchaseOrder.changeStatusPurchaseOrder(id);
    return axiosClient.put<IBaseResponse>(url, body);
  },
};

export default purchaseOrderApi;
